import { InventoryItemCategory, InvoiceLineItem } from "@jugl-web/rest-api";
import { cx, useTranslations } from "@jugl-web/utils";
import { Popover, ListBox } from "@jugl-web/ui-kit";
import { FC, useRef } from "react";
import { useInvoicesItemFormPageContext } from "@web-src/modules/invoices/pages/InvoicesItemFormPage/context/useInvoicesItemFormPageContext";
import { ReactComponent as ChevronIcon } from "./assets/chevron.svg";

export const CategoryCell: FC<{ item: InvoiceLineItem; idx: number }> = ({
  item,
  idx,
}) => {
  const { itemsField } = useInvoicesItemFormPageContext();
  const { t } = useTranslations();
  const wrapperRef = useRef<HTMLDivElement>(null);
  const { category } = item;

  const categoryOptions = [
    {
      id: "item",
      label: t({
        id: "common.item",
        defaultMessage: "Item",
      }),
      value: InventoryItemCategory.item,
    },
    {
      id: "service",
      label: t({
        id: "common.service",
        defaultMessage: "Service",
      }),
      value: InventoryItemCategory.service,
    },
  ];

  const handleCategoryChange = (value: InventoryItemCategory) => {
    itemsField.update(idx, {
      ...item,
      category: value,
    });
  };

  const displayValue = categoryOptions.find(
    (option) => option.value === category
  )?.id;

  const wrapperClassName = cx(
    "group absolute left-px top-px flex h-[calc(100%-2px)] w-[calc(100%-2px)] items-center justify-between border-none px-4 py-3",
    {
      "bg-primary-50 text-primary-800":
        category === InventoryItemCategory.service,
      "bg-secondary-50 text-secondary-800":
        category === InventoryItemCategory.item,
    }
  );

  if (item.inventory_id) {
    return (
      <div className={wrapperClassName}>
        <span className="text-sm capitalize">{displayValue}</span>
      </div>
    );
  }

  return (
    <div className="w-full" ref={wrapperRef}>
      <Popover
        placement="bottom-start"
        className="px-3 py-2"
        renderTrigger={({ Trigger, triggerRef, isOpen }) => (
          <Trigger
            ref={triggerRef}
            className={cx(wrapperClassName, "cursor-pointer")}
          >
            <span className="text-sm capitalize">{displayValue}</span>
            <ChevronIcon
              className={cx(
                "shrink-0 opacity-0 transition-all group-hover:opacity-100",
                isOpen && "rotate-180 opacity-100"
              )}
            />
          </Trigger>
        )}
      >
        {({ onClose }) => (
          <ListBox
            items={categoryOptions}
            selectionBehavior={{ mode: "single", canToggle: true }}
            onSelect={(selectedItem) => {
              handleCategoryChange(selectedItem.value);
              onClose();
            }}
            defaultSelectedIds={[category ?? ""]}
            renderLabel={(option) =>
              categoryOptions.find(({ id }) => id === option.id)?.label
            }
            itemSize="sm"
            spaceBetweenItems="compact"
          />
        )}
      </Popover>
    </div>
  );
};
